import type React from 'react';
import classNames from 'classnames';

import Icons from 'assets/icons';

interface CheckboxIconProps {
  isSelected: boolean;
}

const CheckboxIcon = ({ isSelected }: CheckboxIconProps): React.JSX.Element => (
  <span
    className={classNames(
      'flex-shrink-0 w-4 h-4 rounded border-2 flex items-center justify-center transition-colors duration-100',
      isSelected ? 'border-navy-600 bg-navy-600' : 'border-gray-300'
    )}
  >
    <Icons.Check
      customClass={classNames(
        'w-2.5 h-2.5 text-white transition-opacity duration-100',
        isSelected ? 'opacity-100' : 'opacity-0'
      )}
    />
  </span>
);

export default CheckboxIcon;
